import { makeStyles } from '@material-ui/core';

import { neutral, orange, teal } from 'shared/styles/colors';

export default makeStyles(theme => ({
  root: {
    background: neutral.white,
    width: '100%',
    [theme.breakpoints.up('md')]: {
      background: neutral.white,
    },
  },
  box: {
    padding: '3px',
    [theme.breakpoints.up('md')]: {
      border: `1px solid ${neutral.D10}`,
      backgroundColor: neutral.white,
      padding: '24px',
    },
  },
  container: {
    padding: '24px',
    [theme.breakpoints.up('md')]: {},
  },
  corridorName: {
    fontSize: '0.75rem',
    fontWeight: 600,
    color: teal.D5,
    marginTop: '1rem',
    marginLeft: '1rem',
    '&::first-letter': {
      textTransform: 'uppercase',
    },
  },
  rowBase: {
    fontFamily: 'Poppins Bold',
  },
  productsByCorridorContainer: {
    overflow: 'auto',
    borderRadius: '0.5rem',
    border: `1px solid ${neutral[20]}`,
    height: '100%',
  },
  orderDetailSection: {
    color: neutral[60],
    fontFamily: 'PP Object Sans',
    fontWeight: 500,
    fontSize: '0.875rem',
    padding: '0.75rem 0.75rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
  },
  auditBanner: {
    padding: '0.5rem 0.75rem',
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    color: orange['60'],
    fill: orange['60'],
    backgroundColor: orange['10'],
    '& > .MuiAlert-icon': {
      padding: 0,
      marginRight: '0.5rem',
    },
    '& > .MuiAlert-message': {
      padding: 0,
    },
  },
}));
